module.exports = __webpack_public_path__ + "1791188489487/images/cloud-slash.f6f5a02.svg";